module.exports = __webpack_public_path__ + "img/1.deacb5cf.png";